import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9 4.5C9.27614 4.5 9.5 4.72386 9.5 5V10C9.5 10.2761 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.2761 8.5 10V5C8.5 4.72386 8.72386 4.5 9 4.5Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M3 6.5C3.27614 6.5 3.5 6.72386 3.5 7V10C3.5 10.2761 3.27614 10.5 3 10.5C2.72386 10.5 2.5 10.2761 2.5 10V7C2.5 6.72386 2.72386 6.5 3 6.5Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M6 1.5C6.27614 1.5 6.5 1.72386 6.5 2V10C6.5 10.2761 6.27614 10.5 6 10.5C5.72386 10.5 5.5 10.2761 5.5 10V2C5.5 1.72386 5.72386 1.5 6 1.5Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 6C12.3682 6 12.6667 6.29848 12.6667 6.66667V13.3333C12.6667 13.7015 12.3682 14 12 14C11.6319 14 11.3334 13.7015 11.3334 13.3333V6.66667C11.3334 6.29848 11.6319 6 12 6Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M4.00004 8.66667C4.36823 8.66667 4.66671 8.96514 4.66671 9.33333V13.3333C4.66671 13.7015 4.36823 14 4.00004 14C3.63185 14 3.33337 13.7015 3.33337 13.3333V9.33333C3.33337 8.96514 3.63185 8.66667 4.00004 8.66667Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M8.00004 2C8.36823 2 8.66671 2.29848 8.66671 2.66667V13.3333C8.66671 13.7015 8.36823 14 8.00004 14C7.63185 14 7.33337 13.7015 7.33337 13.3333V2.66667C7.33337 2.29848 7.63185 2 8.00004 2Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M15 7.5C15.4602 7.5 15.8333 7.8731 15.8333 8.33333V16.6667C15.8333 17.1269 15.4602 17.5 15 17.5C14.5397 17.5 14.1666 17.1269 14.1666 16.6667V8.33333C14.1666 7.8731 14.5397 7.5 15 7.5Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M4.99996 10.8333C5.4602 10.8333 5.83329 11.2064 5.83329 11.6667V16.6667C5.83329 17.1269 5.4602 17.5 4.99996 17.5C4.53972 17.5 4.16663 17.1269 4.16663 16.6667V11.6667C4.16663 11.2064 4.53972 10.8333 4.99996 10.8333Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M9.99996 2.5C10.4602 2.5 10.8333 2.8731 10.8333 3.33333V16.6667C10.8333 17.1269 10.4602 17.5 9.99996 17.5C9.53972 17.5 9.16663 17.1269 9.16663 16.6667V3.33333C9.16663 2.8731 9.53972 2.5 9.99996 2.5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 10V7C2.5 6.72386 2.72386 6.5 3 6.5C3.27614 6.5 3.5 6.72386 3.5 7V10C3.5 10.2761 3.27614 10.5 3 10.5C2.72386 10.5 2.5 10.2761 2.5 10ZM5.5 10V2C5.5 1.72386 5.72386 1.5 6 1.5C6.27614 1.5 6.5 1.72386 6.5 2V10C6.5 10.2761 6.27614 10.5 6 10.5C5.72386 10.5 5.5 10.2761 5.5 10ZM8.5 10V5C8.5 4.72386 8.72386 4.5 9 4.5C9.27614 4.5 9.5 4.72386 9.5 5V10C9.5 10.2761 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.2761 8.5 10Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.33337 13.3333V9.33333C3.33337 8.96514 3.63185 8.66667 4.00004 8.66667C4.36823 8.66667 4.66671 8.96514 4.66671 9.33333V13.3333C4.66671 13.7015 4.36823 14 4.00004 14C3.63185 14 3.33337 13.7015 3.33337 13.3333ZM7.33337 13.3333V2.66667C7.33337 2.29848 7.63185 2 8.00004 2C8.36823 2 8.66671 2.29848 8.66671 2.66667V13.3333C8.66671 13.7015 8.36823 14 8.00004 14C7.63185 14 7.33337 13.7015 7.33337 13.3333ZM11.3334 13.3333V6.66667C11.3334 6.29848 11.6319 6 12 6C12.3682 6 12.6667 6.29848 12.6667 6.66667V13.3333C12.6667 13.7015 12.3682 14 12 14C11.6319 14 11.3334 13.7015 11.3334 13.3333Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.16663 16.6667V11.6667C4.16663 11.2064 4.53972 10.8333 4.99996 10.8333C5.4602 10.8333 5.83329 11.2064 5.83329 11.6667V16.6667C5.83329 17.1269 5.4602 17.5 4.99996 17.5C4.53972 17.5 4.16663 17.1269 4.16663 16.6667ZM9.16663 16.6667V3.33333C9.16663 2.8731 9.53972 2.5 9.99996 2.5C10.4602 2.5 10.8333 2.8731 10.8333 3.33333V16.6667C10.8333 17.1269 10.4602 17.5 9.99996 17.5C9.53972 17.5 9.16663 17.1269 9.16663 16.6667ZM14.1666 16.6667V8.33333C14.1666 7.8731 14.5397 7.5 15 7.5C15.4602 7.5 15.8333 7.8731 15.8333 8.33333V16.6667C15.8333 17.1269 15.4602 17.5 15 17.5C14.5397 17.5 14.1666 17.1269 14.1666 16.6667Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconBarChart01: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"bar-chart-01"} {...props} />
);
